<template>
  <div>
    <loading
        :active.sync="loader"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <Header/>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-card class="bCardGlobalXL">
      <div class="text-left mt-4">
        <p style="color: #0069A9; font-weight: 600;">Argumentario para el tratamiento “{{ nombreTratamiento }}”</p>
      </div>
      <div class="text-left mt-4">
        <p style="color: #62B6C2; font-weight: 600;">Archivos multimedia</p>
      </div>
      <div class="text-left mt-4">
        <p style="color: #5A5A5A; font-weight: 400;">Arrastra y suelta tus archivos aquí o haz clic en el botón para seleccionarlos.</p>
      </div>
      <div class="text-left mt-4">
        <input
            type="file"
            ref="fileInput"
            multiple
            accept=".jpg,.png,.mp4"
            style="display: none"
            @change="onFileChange"
        />
        <b-button variant="outline-info" class="rounded-pill" @click="$refs.fileInput.click()" :disabled="listaArchivos.length === maxFiles" size="sm" >Subir archivos <i class="fa fa-plus"  aria-hidden="true"></i> </b-button>
        <div v-if="listaArchivos.length > 0" class="d-flex justify-content-center">
          <p style="font-size: 10px; font-weight: 500">Únicamente se admiten archivos con las extensiones .jpg, .png y .mp4 -
            Puedes agregar máximo 10 archivos -
            25MB por archivo</p>
        </div>
      </div>
      <div  class="drag-and-drop"
            ref="dropArea"
            :class="{ highlight: isDraggingOver }"
            @dragenter.prevent="onDragEnter"
            @dragover.prevent="onDragOver"
            @dragleave.prevent="onDragLeave"
            @drop.prevent="onDrop">

        <div class="content" v-if="listaArchivos.length === 0">
          <em class="subirImagenGris" style="width: 53px; height: 53px"></em>
          <p style="font-size: 12px; font-weight: 500">Únicamente se admiten archivos con las extensiones .jpg, .png y .mp4 <br>
          Puedes agregar máximo 10 archivos <br>
          25MB por archivo</p>
        </div>

        <div v-else-if="listaArchivos.length > 0 && !loader" class="imagesPreview">
          <div v-for="(item, index) in listaArchivos" :key="index" class="preview_item">
            <div style="position: relative" >
              <div v-if="item.file.type.startsWith('image/')" @click="abrirVisor(index)">
                <img :src="item.url" :alt="item.file.name" class="imgPreview"  />
              </div>
              <div class="videoPreview" v-else-if="item.file.type === 'video/mp4'" @click="abrirVisor(index)">
                <em class="playVideo_svg" style="width: 35px; height: 35px"></em>
              </div>
              <em class="close_outline_svg eliminar_item"  @click="eliminarArchivo(index)"></em>
            </div>
            <span class="preview_item_name">{{ item.nombreArchivo }}</span>
          </div>
        </div>

      </div>
      <div v-show="mensajesError.length > 0" class="mt-2 mensajes_error_container">
        <div v-for="(item, index) in mensajesError" :key="index" >
          <span style="color: #FEA246; font-size: 12px;">{{ item }}</span>
        </div>
      </div>
      <div class="text-left mt-4">
        <b-row>
          <b-col cols="4">
            <label class="text-form" for="idCategoria">Categoria:</label>
            <div class="select-wrapper">
              <b-form-select
                  style="font-size: 12px; border-radius: 12px; width: 70%"
                  v-model="idCategoria"
                  :options="listaCategorias"
                  value-field="idCategoria"
                  text-field="titulo"
                  class="custom-select"
                  @click.native="handleSelectChange"
                  @blur.native="isSelectOpen = false"
              >
              </b-form-select>
              <i class="fa fa-chevron-down" aria-hidden="true" :class="{ 'rotate-180': isSelectOpen }"></i>
            </div>
          </b-col>
          <b-col cols="4" class="d-flex align-items-end">
            <label for="checkbox-1" class="mr-2 text-form">¿El argumentario está completo?</label>
            <b-form-checkbox
                id="checkbox-1"
                name="blnArgumentarioCompleto"
                true-value="true"
                false-value="false"
                style="padding-bottom: 0.3rem;"
                v-model="blnArgumentarioCompleto"
                :disabled="listaArchivos.length === 0"
            ></b-form-checkbox>
          </b-col>
        </b-row>
      </div>

      <div class="mt-4 d-flex justify-content-center">
        <b-button variant="info" class="rounded-pill" @click="guardarArgumentario" :disabled="loaderGuardar || idCategoria === null"> <b-spinner small v-if="loaderGuardar"></b-spinner> Guardar</b-button>
      </div>
    </b-card>


    <b-modal v-model="mostrarModal" v-if="listaArchivos.length > 0" size="lg" hide-footer hide-header hide-header-close centered>
      <div class="d-flex justify-content-between mb-3 align-items-center">
        <div>
          <span style="color:#044169; font-weight: 600; font-size: 14px" > Vista previa </span>
        </div>
        <div>
          <button type="button" aria-label="Close" class="close" @click="mostrarModal = false">×</button>
        </div>
      </div>

      <div class="modal-img-container d-flex justify-content-between align-items-center" v-if="archivoActual">
        <em class="chevron_gris rotate-90-left" style="height: 35px" @click="anterior"></em>
        <!-- Contenido dinámico -->
        <template v-if="archivoActual.file.type.startsWith('image/')">
          <img :src="archivoActual.url" class="media-preview" :alt="archivoActual.nombreArchivo" />
        </template>
        <template v-else-if="archivoActual.file.type === 'video/mp4'">
          <video :src="archivoActual.url" controls class="media-preview">
            <track kind="subtitles" src="#" srclang="es" label="Sin subtítulos" />
          </video>

        </template>

        <em class="chevron_gris rotate-90-rigth" style="height: 35px" @click="siguiente"></em>

      </div>
    </b-modal>

  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import {AwsService} from "@/apiServices/aws/AwsService";
import {DeleteObjectCommand, DeleteObjectsCommand, S3Client} from "@aws-sdk/client-s3";
import {Upload} from "@aws-sdk/lib-storage";
import moment from "moment";

export default {
  name: "ArgumentarioV2",
  components: {
    Header
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    dragCounter: 0, // para evitar que se desactive cuando entras/sales de elementos hijos
    isDraggingOver: false,
    isSelectOpen: false,
    nombreTratamiento: "",

    //validaciones archivos
    maxFiles: 10,
    maxSize: 25 * 1024 * 1024, // 25MB
    acceptedTypes: ['image/jpeg', 'image/png', 'video/mp4'],

    listaCategorias:[],
    mensajesError:[],
    idCategoria: null,
    blnArgumentarioCompleto: null,

    listaArchivos: [],

    token: null,
    rutaBase: null,
    awsServicio: new AwsService(),

    mostrarModal: false,
    indiceSeleccionado: 0,
    loader: false,
    loaderGuardar: false,
  }),
  computed: {
    archivoActual() {
      if (this.listaArchivos.length > 0) {
        return this.listaArchivos[this.indiceSeleccionado];
      }
      return null;
    }
  },
  async created() {
    this.nombreTratamiento = this.$route.params.tratamiento
    this.rutaBase = `ARGUMENTARIO/TRATAMIENTO ${this.$route.params.tratamiento} (${this.$route.params.id})`; // Eje: ARGUMENTARIO/TRATAMIENTO RESINA CLASE I (5183)
    this.debug = this.$localStorageService.getDebug();
    this.token = this.$localStorageService.getTokenAWSGenerico();
    await this.validarTokenAWS();
    this.obtenerCategorias();
    this.obtenerConfiguracion();
  },
  methods: {
    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAccesoGenerico().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWSGenerico(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAccesoGenerico().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWSGenerico(this.token)
        })
      }
    },

    obtenerCategorias(){
      this.$http.get(this.$api + 'argumentario/obtenerCategoriaArgumentario').then(response => {
        this.listaCategorias = response.data.data
        // Insertar opción placeholder al inicio
        this.listaCategorias.unshift({
          idCategoria: null, // valor que no debe existir en las categorías reales
          titulo: 'Selecciona una categoría' // texto placeholder
        });
      })
    },

    obtenerConfiguracion(){
      this.loader = true;
      const params= {
        idTratamiento: this.$route.params.id
      }
      this.$http.post(this.$api + 'argumentario/obtenerConfiguracionArgumentario', params).then(response => {
        if (response.data.data){
          const data = response.data.data
          this.blnArgumentarioCompleto = data.argumentarioCompleto;
          this.idCategoria = data.idCategoria
          if (data.listaArchivos.length > 0 && data.listaArchivos !== null) {
            const archivosDesdeServicio = data.listaArchivos.map(archivo => ({
              idArchivoArgumentario: archivo.idArchivoArgumentario,
              file: {
                name: archivo.nombreArchivo,
                type: archivo.extension === 'mp4' ? 'video/mp4' : `image/${archivo.extension}`,
              },
              url: `https://${this.token.nombreBucket}.s3.${this.token.regionBucket}.amazonaws.com/${decodeURIComponent(archivo.urlRuta)}`,
              nombreArchivo: archivo.nombreArchivo,
              urlRuta: archivo.urlRuta,
            }));

            this.listaArchivos = [...archivosDesdeServicio];
          }

          this.loader = false;
        }
      }).catch(error => {
        console.error(error);
        this.loader = false;
      })
    },

    //Funcionalidad Drag - Drop
    onDragEnter() {
      this.dragCounter++;
      this.isDraggingOver = true;
    },
    onDragOver(e) {
      e.preventDefault();
    },
    onDragLeave() {
      this.dragCounter--;
      if (this.dragCounter === 0) {
        this.isDraggingOver = false;
      }
    },
    onDrop(e) {
      this.dragCounter = 0;
      this.isDraggingOver = false;
      const files = Array.from(e.dataTransfer.files);
      this.handleFiles(files);
    },
    onFileChange(e) {
      const files = Array.from(e.target.files);
      this.handleFiles(files);
      this.$refs.fileInput.value = ''; // reset input
    },
    handleFiles(files) {
      const nuevosArchivos = [];
      if (this.listaArchivos.length + files.length > this.maxFiles) {
        this.mostrarMensajeError(`No puedes agregar más de ${this.maxFiles} archivos.`);
        return;
      }

      files.forEach((file , index) => {
        if (!this.acceptedTypes.includes(file.type)) {
          this.mostrarMensajeError(`Archivo no permitido: ${file.name}`);
          return;
        }

        if (file.size > this.maxSize) {
          this.mostrarMensajeError(`El archivo ${file.name} excede los 25MB.`);
          return;
        }

        let extension = file.name.split('.').pop().toLowerCase();
        let nombreArchivo = `${this.nombreTratamiento} ${this.$moment().format("YYYYMMDDHHmmssSSS")}${index}.${extension}`;

        const url = URL.createObjectURL(file);
        nuevosArchivos.push({
          file,
          url,
          nombreArchivo,
          extension
          });
      });
      this.listaArchivos.push(...nuevosArchivos);
    },

    mostrarMensajeError(error) {
      this.mensajesError.push(error);

      setTimeout(() => {
        this.mensajesError = [];
      }, 10000);
    },


    async guardarArgumentario() {
      await this.validarTokenAWS();
      this.loaderGuardar = true;
      const archivosNuevos = this.listaArchivos.filter(item => item.idArchivoArgumentario == null);
      let archivosSubidos = [];

      try {
        // 1. Subir archivos si hay
        if (archivosNuevos.length > 0) {
          archivosSubidos = await this.guardarArchivosArgumentario();
          if (!archivosSubidos || archivosSubidos.length !== archivosNuevos.length) {
            throw new Error("Error al subir archivos a AWS");
          }
        }

        // 2. Guardar en el backend
        const resultado = await this.guardarArg();

        if (!resultado.ok) {
          if (archivosSubidos.length > 0) {
            await this.rollbackArchivos(archivosSubidos);
          }
          throw new Error("Error al guardar en el backend");
        }

        // 3. Éxito
        this.$swal({
          icon: "success",
          title: "Genial",
          text: "Se guardó correctamente",
          showConfirmButton: false,
          timer: 1500,
        });

        this.obtenerConfiguracion();

        this.loaderGuardar = false;

      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error al guardar el argumentario",
          text: error.message || "Error inesperado",
        });
        this.loaderGuardar = false;
      }
    },


    async guardarArchivosArgumentario() {
      const archivosSubidos = [];

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        for (const [index, archivo] of this.listaArchivos.entries()) {
          if (archivo.idArchivoArgumentario == null) {
            const filePath = `${this.rutaBase}/${archivo.nombreArchivo}`;
            const input = {
              Bucket: this.token.nombreBucket,
              Key: filePath,
              Body: archivo.file,
              ContentType: archivo.file.type,
              ACL: 'public-read',
            };

            const upload = new Upload({
              client,
              params: input,
              partSize: 5 * 1024 * 1024,
              queueSize: 4,
            });

            upload.on("httpUploadProgress", (progress) => {
              const porcentaje = Math.round((progress.loaded / progress.total) * 100);
              this.$set(this.listaArchivos[index], "progreso", porcentaje);
            });

            await upload.done();
            archivo.urlRuta = filePath;
            archivosSubidos.push(filePath);
          }else{
            this.$set(this.listaArchivos[index], "progreso", 100);
          }
        }

        return archivosSubidos; // <- ✅ Retorna los archivos subidos

      } catch (error) {
        console.error("Error en la subida a S3:", error);
        this.$swal({
          icon: "error",
          title: "Error en la subida a S3",
          text: error.message,
        })
        throw error; // <- 🔥 Importante: relanza el error para que el flujo principal lo capture
      }
    },


    async guardarArg() {
      const params = {
        argumentarioCompleto: this.blnArgumentarioCompleto,
        idTratamiento: this.$route.params.id,
        nombreTratamiento: this.$route.params.tratamiento,
        idCategoria: this.idCategoria === null ? 1 : this.idCategoria,
        listaArchivos: this.listaArchivos.filter(item => item.idArchivoArgumentario == null),
      };

      try {
        const respuesta = await this.$http.post(this.$api + 'argumentario/guardarArgumentario', params);
        this.guardando = false;

        if (respuesta.data && respuesta.data.data) {
          return { ok: true };
        } else {
          return { ok: false };
        }
      } catch (error) {
        console.error("Error al guardar en backend:", error);
        throw new Error("Error al guardar en el backend");
      }
    },

    async rollbackArchivos(archivosSubidos) {
      if (!archivosSubidos || archivosSubidos.length === 0) return;

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        const deleteParams = {
          Bucket: this.token.nombreBucket,
          Delete: {
            Objects: archivosSubidos.map((filePath) => ({ Key: filePath })),
          },
        };

        const deleteCommand = new DeleteObjectsCommand(deleteParams);
        await client.send(deleteCommand);

        console.log("Rollback exitoso: archivos eliminados de S3.");
      } catch (error) {
        console.warn("Error en rollbackArchivos:", error);
      }
    },

    async eliminarArchivo(index) {
      const archivo = this.listaArchivos[index];

      const resultado = await this.$swal.fire({
        title: '¿Estás seguro?',
        text: 'Este archivo se eliminará permanentemente.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (!resultado.isConfirmed) return;

      if (archivo.url) URL.revokeObjectURL(archivo.url);

      this.listaArchivos.splice(index, 1);

      if (archivo.idArchivoArgumentario) {
        try {
          // 1. Primero desactivar en BD
          const desactivado = await this.desactivarEnBaseDeDatos(archivo);

          // 2. Solo si BD fue exitoso, borrar de S3
          if (desactivado) {
            await this.eliminarDeAWS(archivo);
          }
        } catch (error) {
          console.error("Error en eliminación:", error);
          await this.$swal.fire(
              'Error',
              'Ocurrió un error al eliminar el archivo. Intenta de nuevo.',
              'error'
          );
        }
      }else{
        await this.$swal.fire({
          title: 'Éxito',
          text: 'Archivo eliminado correctamente.',
          icon: 'success',
        });
      }
    },

    async desactivarEnBaseDeDatos(archivo) {
      try {
        const response = await this.$http.post(
            `${this.$api}argumentario/desactivarArchivoArgumentario`,
            { idArchivoArgumentario: archivo.idArchivoArgumentario }
        );

        return response.status === 200;
      } catch (error) {
        console.error("Falló desactivación en BD:", error);
        return false;
      }
    },

    async eliminarDeAWS(archivo) {
      await this.validarTokenAWS();

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        const deleteCommand = new DeleteObjectCommand({
          Bucket: this.token.nombreBucket,
          Key: archivo.urlRuta, // Asegúrate que esta propiedad es correcta
        });

        await client.send(deleteCommand);
        console.log("Archivo eliminado de S3");
        await this.$swal.fire({
          title: 'Éxito',
          text: 'Archivo eliminado correctamente.',
          icon: 'success',
        });
      } catch (error) {
        console.error("Error eliminando de S3:", error);
        console.error("Error en eliminación:", error);
        await this.$swal.fire(
            'Error',
            'Ocurrió un error al eliminar el archivo de S3. Intenta de nuevo.',
            'error'
        );
      }
    },

    handleSelectChange() {
      this.isSelectOpen = !this.isSelectOpen;
    },

    abrirVisor(index) {
      this.indiceSeleccionado = index;
      this.mostrarModal = true;
    },

    siguiente() {
      this.indiceSeleccionado =
          (this.indiceSeleccionado + 1) % this.listaArchivos.length;
    },
    anterior() {
      this.indiceSeleccionado =
          (this.indiceSeleccionado - 1 + this.listaArchivos.length) % this.listaArchivos.length;
    }


  }
}
</script>

<style scoped>
.drag-and-drop {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.content{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
}

.drag-and-drop.highlight {
  background-color: #f0f8ff;
  border-color: #4a90e2;
  border-radius: 12px;
}

.imagesPreview{
  display: flex;
  gap: 12px;
  padding: 8px 0;
  flex-wrap: wrap;
}

.imgPreview  {
  width: 100px;
  height: 100px;
  border-radius: 5px;
  object-fit: cover;
  position: relative;
}

.videoPreview {
  width: 100px;
  height: 100px;
  border-radius: 5px;
  position: relative;
  align-content: center;
  border: 1px solid #62B6C2;
}

.preview_item{
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 150px;
}

.preview_item_name{
  padding: 0.5rem;
  word-break: break-word;
  color: #5D5D5D;
  font-size: 10px;
}

.eliminar_item{
  position: absolute;
  right: -5px;
  top: -5px;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.text-form{
  font-size: 10px;
}

.custom-select{
  background: none;
}

.select-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.select-wrapper i {
  position: absolute;
  top: 50%;
  right: 32%; /* mejor que left: 65% */
  transform: translateY(-50%);
  pointer-events: none;
  color: #6c757d;
  font-size: 10px;
  transition: transform 0.3s ease;
}

.select-wrapper i.rotate-180 {
  transform: translateY(-50%) rotate(180deg);
  transition: transform 0.3s ease-in-out;
}

.mensajes_error_container{
  transition: all 0.5s ease;
}

.modal-img-container{
  min-height: 342px;
}

.media-preview {
  width: 584px;
  max-height: 342px;
  object-fit: cover;
  border-radius: 10px;
  aspect-ratio: 16 / 9;
}

.rotate-90-left{
  transform: rotate(90deg);
}

.rotate-90-rigth{
  transform: rotate(-90deg);
}
</style>